import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { AppError, FieldValidationError } from '@rms/sdk/errors';

export function problemDetailCode(error: HttpErrorResponse): string | null {
  const body: unknown = error.error;

  return typeof body === 'object' && body !== null && 'code' in body && typeof body.code === 'string'
    ? body.code
    : null;
}

/** A 400 carries per-field errors for a form; any other failure is a plain error with the same message. */
export function toFormError(error: HttpErrorResponse, translationKey: string): AppError | FieldValidationError {
  return error.status === HttpStatusCode.BadRequest
    ? new FieldValidationError(error, translationKey)
    : AppError.from(error, translationKey);
}
